var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.panelWidth},[_c('table',{staticClass:"table table-data table-hover table-striped table-condensed"},[_c('thead',[_c('tr',[_vm._t("head")],2)]),_c('tbody',[_vm._t("body")],2),_c('tfoot',[_vm._t("foot")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }